//Types
export const Types = {
    LOGIN: "LOGIN",
    VERIFY_SESSION: "VERIFY_SESSION",
    LOGOUT: "LOGOUT",
    SET_LOADING: "SET_LOADING_SESSION",
}

//Reducer
const initialState = {
    currentUser: null,
    loading: false,
}

const Session = (state = initialState, action) => {
    switch(action.type) {
        case(Types.LOGIN):
            return {
                ...state,
                currentUser: action.payload,
            }

        case(Types.VERIFY_SESSION):
            return {
                ...state,
                currentUser: action.payload,
                loading: false,
            }
        case(Types.LOGOUT):
            return {
                ...state,
                currentUser: null,
                loading: false,
            }
        case Types.SET_LOADING:
            return {
                ...state,
                loading: true
            }

        default:
            return state;
    }
}

export default Session;
